import React from 'react';

const CheckoutPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Checkout</h1>
        <p className="text-gray-500">Coming soon...</p>
      </div>
    </div>
  );
};

export default CheckoutPage;
